export default __webpack_public_path__ + "static/media/arrow-prev.e59b1d6a.svg";